<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import OptionBox from '@/components/cloudCounter/OptionBox.vue';
import selectBox from '@/components/cloudCounter/SelectBox.vue';

import { useRouter } from 'vue-router';
const router = useRouter();

const goNextPage = () => {
    // router.push({name:''})
}

// 日期選單情境
const options = ref({
    inputValue: '',
    inputOptions: [
        {
            title: '113年8月2日',
            optionValue: '2024-08-02'
        },
        {
            title: '113年8月3日',
            optionValue: '2024-08-03'
        }
    ]
});

const timeValue = ref('');
const setTimeValue = (data) => {
    if (data) {
        timeValue.value = data;
    }
};

</script>

<template>

    <Layout :header="{ text: '要保人或被保險人姓名變更', backBtn: { visible: true }, closeBtn: { visible: false, to: {} } }">

        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫資料', '確認資料', '視訊預約',]" :index="3" />
        </div>

        <div class="pb-8">
            <h2 class="font-bold text-2xl">
                預約視訊驗證
            </h2>
            <p class="pt-2">
                此次變更需由專人與您及被保險人線上進行視訊驗證，請選擇以下時間。
            </p>
        </div>

        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">
                視訊日期
            </h3>
            <OptionBox :inputOption="option" inputType="radio" :inputValue="options.inputValue"
                :setInputValue="(data) => { options.inputValue = data; }" v-for="option in options.inputOptions" />

        </div>

        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">
                視訊時間
            </h3>

            <selectBox :timeValue="timeValue" :setTimeValue="setTimeValue" placeholder="請選擇視訊時間" :boxData="{
        boxTitle: '請選擇視訊時間',
        options: [
            '09:00 - 10:00',
            '09:30 - 10:30',
            '10:00 - 11:00',
            '10:30 - 11:30',
            '11:00 - 12:00',
            '13:00 - 14:00',
            '13:30 - 14:30',
            '14:00 - 15:00',
            '14:30 - 15:30',
            '09:00 - 10:00',
            '09:30 - 10:30',
            '10:00 - 11:00',
            '10:30 - 11:30',
            '11:00 - 12:00',
            '13:00 - 14:00',
            '13:30 - 14:30',
            '14:00 - 15:00',
            '14:30 - 15:30',
            '09:00 - 10:00',
            '09:30 - 10:30',
            '10:00 - 11:00',
            '10:30 - 11:30',
            '11:00 - 12:00',
            '13:00 - 14:00',
            '13:30 - 14:30',
            '14:00 - 15:00',
            '14:30 - 15:30',
            '15:00 - 16:00'
        ]
    }" />

        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled=" options.inputValue === '' || timeValue === ''" 
                @click="goNextPage">下一步</button>
        </template>

    </Layout>

</template>

<style scoped></style>
